import axios, { AxiosError } from 'axios';
import { getAuthHeader } from './auth.service';

const API_URL = process.env.REACT_APP_API_URL || 'https://cccgnv.appgsi.com/api/v1';

export interface Cylinder {
  NUMERO_SERIAL_CILINDRO: string;
  MARCA_CILINDRO: string;
  CAPACIDAD_CILINDRO: string;
  FECHA_FABRICACION_CILINDRO: string;
  FECHA_ULTIMA_PH_CILINDRO: string;
  FECHA_PROXIMA_PH_CILINDRO: string;
}

export interface Regulator {
  NUMERO_SERIAL_REGULADOR: string;
  MARCA_REGULADOR: string;
}

export interface VehicleInfo {
  NIT_TALLER_ULTIMA_CERTIFICACION: string;
  NOMBRE_TALLER_ULTIMA_CERTIFICACION: string;
  CIUDAD_UBICACION_TALLER: string;
  PLACA: string;
  VIN: string;
  FECHA_INSTALACION: string;
  CHIP_IDROM: string;
  FECHA_ULTIMA_REVISION_ANUAL: string;
  FECHA_PROXIMA_REVISION_ANUAL: string;
  CILINDROS: Cylinder[];
  REGULADORES: Regulator[];
}

export interface VehicleResponse {
  result: VehicleInfo;
  status: number;
  statusText: string;
}

interface ApiErrorResponse {
  message: string;
  status?: number;
}

export const getErrorMessage = (error: any, placa: string): string => {
  if (axios.isAxiosError(error)) {
    const axiosError = error as AxiosError<ApiErrorResponse>;
    if (axiosError.response) {
      if (axiosError.response.status === 404) {
        return `No se encontró información para el vehículo con placa ${placa}. Verifique que la placa sea correcta.`;
      }
      if (axiosError.response.status === 401) {
        return 'Su sesión ha expirado. Por favor, vuelva a iniciar sesión.';
      }
      return axiosError.response.data?.message || 'Error al consultar el vehículo. Por favor, intente nuevamente.';
    }
    if (axiosError.request) {
      return 'No se pudo conectar con el servidor. Por favor, verifique su conexión a internet.';
    }
  }
  return 'Error desconocido. Por favor, intente nuevamente.';
};

export const getVehicleInfo = async (placa: string): Promise<VehicleResponse> => {
  try {
    console.log('Headers de autorización:', getAuthHeader()); // Debug
    const response = await axios.post(
      `${API_URL}/Certificate/getCertificate`,
      { placa },
      { 
        headers: {
          ...getAuthHeader(),
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error al obtener información del vehículo:', error);
    throw new Error(getErrorMessage(error, placa));
  }
};
